const CART_KEY = "ttbgCart";

// Deux lignes sont « le même produit » si produit, couleur, marquage et faces sont identiques.
const cartItemKey = (item) =>
  [
    item.product && (item.product.id || item.product.slug || item.product.title),
    item.color && item.color.Nom,
    item.marquage,
    item.faces,
  ].join("|");

// Additionne les quantités des lignes identiques (conserve l'ordre d'ajout).
export const mergeCartItems = (items) =>
  items.reduce((acc, item) => {
    const existing = acc.find((i) => cartItemKey(i) === cartItemKey(item));
    if (existing) {
      existing.quantity = String(+existing.quantity + +item.quantity);
    } else {
      acc.push({ ...item });
    }
    return acc;
  }, []);

export const readCart = () => {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    return mergeCartItems(JSON.parse(localStorage.getItem(CART_KEY) || "[]"));
  } catch (e) {
    return [];
  }
};

export const writeCart = (items) => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.setItem(CART_KEY, JSON.stringify(items));
};

export const addCartItem = (item) => {
  const newCart = mergeCartItems([...readCart(), item]);
  writeCart(newCart);
  return newCart;
};
